'use strict';

export {I18nComponent} from './I18nComponent';
export * from './utils';



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-i18n/index.js